@if (visible) {
  <div
    class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto"
    role="presentation">

    <section
      #dialog
      class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg my-auto"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="heading ? headingId : null"
      [attr.aria-label]="heading ? null : ariaLabel"
      [attr.aria-describedby]="messageId"
      tabindex="-1"
      (keydown)="onKeydown($event)">

      @if (heading) {
        <h2 [id]="headingId" class="text-xl font-semibold mb-4">{{ heading }}</h2>
      }

      <div [id]="messageId" class="mb-4">
        <ng-content></ng-content>
      </div>

      <div class="flex justify-end">
        <prism-btn btnType="button" (click)="ok.emit()">{{ okText }}</prism-btn>
      </div>

      <span class="sr-only" aria-live="polite">{{ tabAnnouncement }}</span>
    </section>
  </div>
}
